import i18next from 'i18next'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'
import { DID } from 'app/constants/identityActions'
import DifferentActivitiesList from './DifferentActivitiesList'
import { getDifferentActivitiesPending } from 'store/entities/differentActivities/selectors'
import { tryDifferentActivity } from 'store/entities/differentActivities/actions'
import ConfirmOrCancel from 'app/components/Modals/ConfirmOrCancel'
import { modal } from 'store/entities/modal/actions'
import { sendYesterdayActivity } from 'store/entities/identity/actions'
import {
  getIdentityCanCompletePreviousActivityInWorkday,
  getIdentityLastUserActivity,
} from 'store/entities/identity/selectors'

const mapDispatchToProps = {
  tryDifferentActivity,
  showModal: modal.show,
  hideModal: modal.hide,
  sendYesterdayActivity,
}

const mapStateToProps = createStructuredSelector({
  pending: getDifferentActivitiesPending,
  showPreviousActivityConfirmModal: getIdentityCanCompletePreviousActivityInWorkday,
  lastActivity: getIdentityLastUserActivity,
})

const mergeProps = (
  { lastActivity, showPreviousActivityConfirmModal, ...restState },
  { showModal, hideModal, tryDifferentActivity, sendYesterdayActivity, ...restProps },
  ownProps
) => ({
  ...restState,
  ...restProps,
  ...ownProps,
  tryDifferentActivity: activityId => {
    if (showPreviousActivityConfirmModal) {
      showModal(ConfirmOrCancel, {
        confirmBtn: i18next.t('user:I Did It'),
        title: i18next.t('user:Did you complete your previous MicroAction?'),
        handleSubmit: () => {
          sendYesterdayActivity({
            activityId: lastActivity.get('id'),
            userActivityId: lastActivity.get('userActivityId'),
            actionType: DID,
          })
          tryDifferentActivity(activityId)
          hideModal()
        },
        onRequestClose: () => {
          tryDifferentActivity(activityId)
          hideModal()
        },
      })
    } else {
      tryDifferentActivity(activityId)
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withTranslation('user')(DifferentActivitiesList))
